import type { KycActionState } from '@modules/account'

interface WalletTransactGateInput {
  // Account access restricted (blocked account) — hard block, beats everything.
  restricted: boolean
  // KYC lifecycle gate, mirroring the nav (see resolveKycActionState).
  kycState: KycActionState
  // At least one linked bank account (any verification status).
  hasBankAccount: boolean
  // At least one *verified* ('active') bank account.
  hasActiveBank: boolean
}

// Single source of truth for whether the fiat wallet's Add Funds / Withdraw
// actions are available. Money moves only when the account isn't restricted AND:
//   • KYC verified  → a linked bank exists, or
//   • KYC in review → a *verified* (active) bank exists (the investor has
//                     submitted KYC and is just awaiting admin sign-off).
// Every other state ('action-required', in-review without a verified bank)
// blocks the deposit/withdraw drawers. Shared by the tab (button + drawer
// gating), the container (deep-link deposit guard), and the Quick Actions card.
export const canTransactInWallet = ({
  restricted,
  kycState,
  hasBankAccount,
  hasActiveBank,
}: WalletTransactGateInput): boolean => {
  if (restricted) return false
  if (kycState === 'verified') return hasBankAccount
  if (kycState === 'in-review') return hasActiveBank
  return false
}
